import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout } from 'element-react';
import "./index.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import Navigation from "../../components/navigation";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dicts: [],
      form: {
        name: '',
        identityAccount: '',
        gender: '',
        age: '',
        phone: '',
        nation: '',
        complaintTitle: '',
        categoryId: '',
        complaintContent: '',
        dept_id: '',
        dept_name: '',
        source: '2',
        complaintStatus: '1',
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        identityAccount: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号'));
            } else {
              if (this.state.form.identityAccount !== '') {
                var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (!pattern.test(this.state.form.identityAccount)) {
                  callback(new Error('请输入正确的证件号码'));
                }
              }
              callback();
            }
          } }
        ],
        gender: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        age: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            var age = parseInt(value, 10);
            setTimeout(() => {
              if (!Number.isInteger(age)) {
                callback(new Error('请输入数字值'));
              }
            }, 1000);
          }, trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入联系电话'));
            } else {
              if (this.state.form.phone !== '') {
                var pattern = /^1[0-9]{10}$/;
                if (!pattern.test(this.state.form.phone)) {
                  callback(new Error('请输入正确的联系方式'));
                }
              }
              callback();
            }
          } }
        ],
        nation: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        complaintTitle: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        complaintContent: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      }
    };
  }

  componentDidMount() {
    Http.get(Request.get_dict(), {}, obj => {
      if (obj.code == 200) {
        this.setState({
          dicts: obj.data
        })
      }
    });
    Http.get(Request.getOrgTree(), {parentId:'0'}, obj => {
      if (obj.code == 200) {
        this.setState({
          treeData: obj.data
        })
      }
    });
  }

  handleSubmit(e) {
    const { form } = this.state;
    e.preventDefault();
  
    this.refs.form.validate((valid) => {
      console.log('valid1111111', valid, form)
      if (form.name == '' || form.identityAccount == '' || form.gender == '' || form.age == '' || form.phone == '' || form.nation == '' || form.complaintTitle == '' || form.categoryId == '' || form.complaintContent == ''||form.dept_id == ''||form.dept_name == '') {
        Message.error('必填项不能为空')
        return false;
      }
      if (valid) {
        Http.postJson(Request.saveComplaint(), form, obj => {
          if (obj.code == 200) {
            Message.success('保存成功！');
            let form = {
              name: '',
              identityAccount: '',
              gender: '',
              age: '',
              phone: '',
              nation: '',
              complaintTitle: '',
              categoryId: '',
              complaintContent: '',
              dept_id: '',
              dept_name: '',
              source: '2',
              complaintStatus: '1',
            }
            this.setState({
              form: form
            })
            this.refs.form.resetFields();
            return;
          } else {
            Message.error(obj.msg);
            return;
          }
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  handleReset(e) {
    e.preventDefault();
    let form = {
      name: '',
      identityAccount: '',
      gender: '',
      age: '',
      phone: '',
      nation: '',
      complaintTitle: '',
      categoryId: '',
      complaintContent: '',
      dept_id: '',
      dept_name: '',
      source: '2',
      complaintStatus: '1',
    }
    this.setState({
      form: form
    })
    this.refs.form.resetFields();
  }
  
  onChange(key, value) {
    let form = this.state.form;
    if (key == 'dept') {
      if (value && value.value) {
        form.dept_id = value.value;
        form.dept_name = value.label;
      }
      this.setState({
        form: form
      })
    } else {
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }

  onBlur(key, e) {
    var value = e.target.value;
    if (value && value != '') {
      if (key == 'identityAccount') {
        var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的证件号码');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'age') {
        var age = parseInt(value, 10);
        if (!Number.isInteger(age)) {
          Message.error('请输入数字值');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'phone') {
        var pattern = /^1[0-9]{10}$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的联系方式');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }

  onLoadData = treeNode => new Promise((resolve) => {
    Http.get(Request.getOrgTree(), {parentId:treeNode.props.eventKey}, obj => {
      if (obj.code == 200) {
        setTimeout(() => {
          // treeNode.props.children.concat(obj.data);
          this.state.treeData.map(function (r, i) {
            if (r.id == treeNode.props.eventKey) {
              r.children = obj.data;
            }
          })
          this.setState({
            treeData: [...this.state.treeData],
          });
          resolve();
        }, 200);
      }
    });
  })
  
  render() {
    const { dicts,treeData } = this.state;
    
      return (
        <div className="complaint-container">
          <Navigation />
          <Form ref="form" model={this.state.form} rules={this.state.rules} labelWidth="80" className="demo-ruleForm">
            <Row gutter={8}>
              <Col sm={{ span: 8 }}>
                <Form.Item label="姓名" props="name" required={true}>
                  <Input placeholder="请输入" value={this.state.form.name} onChange={this.onChange.bind(this, 'name')} maxLength={10}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="身份证号" props="identityAccount" required={true}>
                  <Input placeholder="请输入" value={this.state.form.identityAccount} onChange={this.onChange.bind(this, 'identityAccount')} onBlur={this.onBlur.bind(this, 'identityAccount')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="性别" props="gender" required={true}>
                  <Select value={this.state.form.gender.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'gender')} style={{width: 308}}>
                    <Select.Option label="男" value="1"></Select.Option>
                    <Select.Option label="女" value="2"></Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="年龄" props="age" required={true}>
                  <Input placeholder="请输入" value={this.state.form.age} onChange={this.onChange.bind(this, 'age')} onBlur={this.onBlur.bind(this, 'age')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="联系电话" props="phone" required={true}>
                  <Input placeholder="请输入" value={this.state.form.phone} onChange={this.onChange.bind(this, 'phone')} onBlur={this.onBlur.bind(this, 'phone')}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="民族" props="nation" required={true}>
                  {/* <Input placeholder="请输入" value={this.state.form.nation} onChange={this.onChange.bind(this, 'nation')}></Input> */}
                  <Select value={this.state.form.nation.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'nation')} style={{ width: 308 }}>
                    {dicts && dicts.length > 0 && dicts.map(function(item, i) {
                      if (item.code == 'nation') {
                        return (
                          item.children.map(function(r, j) {
                            return <Select.Option label={r.dictValue} value={r.dictValue}></Select.Option>
                          })
                        )
                      }
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="投诉单位" props="dept" required={true} className="select-tree">
                  <TreeSelect
                    // disabled={func.notEmpty(detail.id)}
                    style={{ width: 310 }}
                    // value={{value: this.state.form.dept_id,label: this.state.form.dept_name}}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    treeData={treeData}
                    allowClear
                    showSearch
                    labelInValue
                    onChange={this.onChange.bind(this, 'dept')}
                    loadData={this.onLoadData}
                    treeNodeFilterProp="title"
                    placeholder="请选择"
                  />
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="数据来源" props="source" required={true}>
                  <Select value={this.state.form.source.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'source')} style={{ width: 308 }}>
                    <Select.Option label="终端机" value="1"></Select.Option>
                    <Select.Option label="门户" value="2"></Select.Option>
                    <Select.Option label="后台" value="3"></Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 8 }}>
                <Form.Item label="处理状态" props="complaintStatus" required={true}>
                  <Select value={this.state.form.complaintStatus.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'complaintStatus')} style={{ width: 308 }}>
                    <Select.Option label="未回复" value="1"></Select.Option>
                    <Select.Option label="已回复" value="2"></Select.Option>
                  </Select>
                </Form.Item>
              </Col>      
              <Col sm={{ span: 24 }}>
                <Form.Item label="标题" props="complaintTitle" required={true}>
                  <Input placeholder="请输入" value={this.state.form.complaintTitle} onChange={this.onChange.bind(this, 'complaintTitle')} maxLength={100}></Input>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="类别" props="categoryId" required={true}>
                  <Radio.Group value={this.state.form.categoryId} onChange={this.onChange.bind(this, 'categoryId')}>
                    {dicts && dicts.length > 0 && dicts.map(function(item, i) {
                      if (item.code == 'complaint') {
                        return (
                          item.children.map(function(r, j) {
                            return <Radio value={r.id}>{r.dictValue}</Radio>
                          })
                        )
                      }
                    })}
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col sm={{ span: 24 }}>
                <Form.Item label="反应投诉建议详细情况：请勿填写泄露后可能损害国家在政治、经济、国防、外交等领域涉及国家安全和利益的事项。" props="category" className="input-textarea" required={true}>
                  <Input
                    type="textarea"
                    // autosize={{ minRows: 1, maxRows: 5 }}
                    rows={5}
                    value={this.state.form.complaintContent}
                    onChange={this.onChange.bind(this, 'complaintContent')}
                    placeholder="请勿填写原部队情况和所参加任务的详情信息，可简要填写反馈问题发生的时间、地点、事情经过和结果以及退役后所在的工作单位、工作现状等内容"
                    maxLength={1000}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="form-footer">
              <div className="form-btn" onClick={this.handleSubmit.bind(this)}>保存</div>
              <div className="form-btn form-btn1" onClick={this.handleReset.bind(this)}>重置</div>
            </div>
          </Form>
        </div>
    );
  }
}
